import { render, staticRenderFns } from "./NegociaoNegociacoes.vue?vue&type=template&id=66894d09"
import script from "./NegociaoNegociacoes.vue?vue&type=script&lang=js"
export * from "./NegociaoNegociacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports